/* global process */
let adminBase = window._env_.VUE_APP_ADMIN_HOST

const queryBatchUpload = params => {
  return axios.post(`${adminBase}/excel/query_upload`, params)
}
const downSourceFile = params => {
  return `${adminBase}/excel/down_sourc_file_` + params.id
}
const downErrorFile = params => {
  return `${adminBase}/excel/down_error_file_` + params.id
}
const downUnprocessFile = params => {
  return `${adminBase}/excel/down_unprocess_file_` + params.id
}
const downExportFile = params => {
  return `${adminBase}/excel/down_export_file_${params.id}`
}
const downEncryptExportFile = params => {
  return `${adminBase}/batch_jobs/down_encrypt_export_file_${params.id}.7z`
}
const cancelTaskBatch = params => {
  return axios.post(`${adminBase}/excel/cancel_${params.id}`, params)
}
const createTaskBatch = params => {
  return axios.post(`${adminBase}/excel/create_upload`, params)
}
const createExecuteTaskBatch = params => {
  return axios.post(`${adminBase}/excel/create_execute_upload`, params)
}

export default {
  queryBatchUpload,
  downSourceFile,
  downErrorFile,
  downUnprocessFile,
  downExportFile,
  downEncryptExportFile,
  cancelTaskBatch,
  createTaskBatch,
  createExecuteTaskBatch,
}



// WEBPACK FOOTER //
// ./src/components/Batchjobs/api.js